module.exports = __webpack_public_path__ + "static/media/recardio-nav.ec59e1cc.png";